"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _keyframes = require("./keyframes");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    position: absolute;\n    top: 0;\n    left: 0;\n    will-change: transform;\n    transform: translateZ(0);\n    ", ";\n    animation: ", "\n        ", " linear\n        ", " backwards;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var base = function base(_ref) {
  var theme = _ref.theme,
      column = _ref.column;
  return {
    height: column ? theme.shapeHeight : '100%',
    width: theme.shapeWidth
  };
};

var ShapeWrapper = _styledComponents["default"].div(_templateObject(), function (props) {
  return base(props);
}, function (props) {
  return props.animationName || (props.column ? _keyframes.shapeColumn : _keyframes.shape);
}, function (props) {
  return props.duration;
}, function (props) {
  return props.infinite ? 'infinite' : props.theme.palette.transitionDuration;
});

var _default = ShapeWrapper;
exports["default"] = _default;